import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrSurvey } from '../../../../../../shared/types/modules/pqr';

export const usePqrSurveyDetail = (pqrSurvey?: PqrSurvey) => {
    const formik = useFormik({
        initialValues: {
            question1: '',
            question2: '',
            question3: '',
            question4: '',
            question5: '',
            question6: '',
            question7: '',
            question8: '',
            question9: '',
            question10: '',
            question11: '',
        },
        onSubmit: console.log,
    });
    useEffect(() => {
        formik.setValues({
            question1: pqrSurvey?.question1 || '',
            question2: pqrSurvey?.question2 || '',
            question3: pqrSurvey?.question3 || '',
            question4: pqrSurvey?.question4 || '',
            question5: pqrSurvey?.question5 || '',
            question6: pqrSurvey?.question6 || '',
            question7: pqrSurvey?.question7 || '',
            question8: pqrSurvey?.question8 || '',
            question9: pqrSurvey?.question9 || '',
            question10: pqrSurvey?.question10 || '',
            question11: pqrSurvey?.question11 || '',
        });
    }, [pqrSurvey]);

    return {
        formik,
    };
};
